jQuery(document).ready(function($) { 
	var formatter = new Intl.NumberFormat('en-US', {
  		style: 'currency',
  		currency: 'GBP',
	});
	
	$('.calc__submit').on('click', function() {
		runCalculator();
	})

	function runCalculator() {
		var fobs = $('#calc-fobs').val();
		//var hours = Math.ceil($('#calc-hours').val() * fobs * 4.3);
		var hours =  $('#calc-hours').val() * fobs * 4.3;
		var validation = false;

		if(fobs == '' || hours == '') {
			$('.calc__output').css('display', 'none');
			$('.calc__error').css('display', 'block');
			validation = false;
		} else {
			$('.calc__error').css('display', 'none');
			var price = calculatePrice(fobs, hours);
			price = formatter.format(price);
			$('.calc__output').text('Your membership cost would be ' + price + ' (excl VAT) this month.');
			$('.calc__output').css('display', 'block');
			validation = true;
		}

		return validation;
	}

	function calculatePrice(fobs, hours) {
		var price = 300 + (fobs * 10);
		hours -= 75;

		switch(true) {
			case (hours < 1):
        		break;
			case (hours >= 1):
				price += (hours * 3.5);
				break;
			default:
        		break;
		}
		return price ;
	}

	$('.calc__email').on('click', function() {
		if(runCalculator()) {
			source = $(this).attr('source');
			setPopupFormDetails(source);
			clearText();
			$('.signup-popup-calc').slideDown('slow');
			$('body').addClass('modal-active');
		}
	})

	$('.popup-calc-signup').on('click', function() {
		var email = $('#signup-email-calc').val();
		if (!validateEmail(email)) {
			clearText();
			$('.signup-response-error').text('Please enter a valid email address');
		} else {
			var fobs = $('#calc-fobs').val();
			var hours = Math.ceil($('#calc-hours').val() * fobs * 4.3);
			var price = calculatePrice(fobs, hours);
			price = formatter.format(price);
			addEmailToEbuildCalc(email, source, fobs, hours, price);
		}
	})

	function addEmailToEbuildCalc(email, source, fobs, hours, price) {
		$.ajax({  
			type: 'GET',  
			url: ajaxStuff.ajax_url, 
			dataType: 'json',
			data: {  
			    action: 'popup_register',
			    email: email,
			    source: source,
			    fobs: fobs,
			    hours: hours,
			    price: price
			}, 
			success: function(response){ 
				if(response == '1') {
					clearText();
			   		$('.signup-response, .signup-response-register').text("Thanks, you have been added to our database and can expect to receive your email estimate soon!");
			   	} else {
			   		clearText();
			   		$('.signup-response-error .signup-response-register-error').text('Unfortunately, we encountered an error. Please try again later.');
			   	}
			},  
			error: function(MLHttpRequest, response, errorThrown){  
			    console.log('Error');
			    console.log(errorThrown);
			    clearText();
			    $('.signup-response-error, .signup-response-register-error').text('Unfortunately, we encountered an error. Please try again later.');
			}  
		});
	}




	var source = "";

	$('.open-signup').on('click', function() {
		source = $(this).attr('source');
		setPopupFormDetails(source);
		clearText();
		$('.signup-popup').slideDown('slow');
		$('body').addClass('modal-active');
	})

	function setPopupFormDetails(source) {
		$('.hs-form-container, .confirm_form').hide();

		switch(source) {
			case 'VIP tour':
				$('.signup-popup__title').html('Want to request a VIP tour and discover more about the <span>Old Bond Store</span>?');
				$('.confirm_form').show();
				break;
			case 'More information':
				$('.signup-popup__title').html('Want to discover more about the <span>Old Bond Store</span>?');
				$('.hs-form-container#more-information-hs-form').show();
				break;
			case 'Meet and collaborate':
				$('.signup-popup__title').html('Want to meet and collaborate with others from the <span>Old Bond Store</span>?');
				$('.confirm_form').show();
				break;
			case 'Calulate member price':
				$('.signup-popup__title').html('Want to request a membership cost email breakdown for the <span>Old Bond Store</span>?');
				$('.confirm_form').show();
				break;
			default:
				$('.signup-popup__title').html('Want to discover more about the <span>Old Bond Store</span>?');
				$('.confirm_form').show();
				break;
		}
	}

	$('.signup-popup__close').on('click', function() {
		clearText();
		$('.signup-popup, .signup-popup-calc').slideUp('slow');
		$('body').removeClass('modal-active');
	})

	$('.popup-signup').on('click', function() {
		var email = $('#signup-email').val();
		if (!validateEmail(email)) {
			clearText();
			$('.signup-response-error').text('Please enter a valid email address');
		} else {
			addEmailToEbuild(email, source);
		}
	})

	$('.popup-signup-register').on('click', function() {
		var email = $('#signup-email-register').val();
		if (!validateEmail(email)) {
			clearText();
			$('.signup-response-register-error').text('Please enter a valid email address');
		} else {
			source = 'More articles';
			addEmailToEbuild(email, source);
		}
	})

	function addEmailToEbuild(email, source) {
		$.ajax({  
			type: 'GET',  
			url: ajaxStuff.ajax_url, 
			dataType: 'json',
			data: {  
			    action: 'popup_register',
			    email: email,
			    source: source,
			}, 
			success: function(response){ 
				if(response == '1') {
					clearText();
			   		$('.signup-response, .signup-response-register').text("Thanks, you have been added to our database. You can look forward to more great content whizzing it's way to your inbox soon!");
			   	} else {
			   		clearText();
			   		$('.signup-response-error .signup-response-register-error').text('Unfortunately, we encountered an error. Please try again later.');
			   	}
			},  
			error: function(MLHttpRequest, response, errorThrown){  
			    console.log('Error');
			    console.log(errorThrown);
			    clearText();
			    $('.signup-response-error, .signup-response-register-error').text('Unfortunately, we encountered an error. Please try again later.');
			}  
		});
	}

	function clearText() {
		$('.signup-response, .signup-response-register, .signup-response-error, .signup-response-register-error').text('');
	}

	$('#launchNextExisting').on('click', function() {

		$('#launchError').css('display', 'none');

		if ($('#launchCode').val() != "") {
			console.log('here');
			$.ajax({  
			    type: 'GET',  
			    url: ajaxStuff.ajax_url, 
			    dataType: 'json',
			    data: {  
			        action: 'get_findMemberDetails',
			        code: $('#launchCode').val(),
			    }, 
			    success: function(response){ 
			    	console.log(response);
			    	if (response.length != 0) {
				    	$('#existingUser').toggle();
				    	$('#launchConfirmExisting').css('display', 'flex');
				        $('#launchEmail').val(response[0].email);
				        $('#launchName').val(response[0].name);
				        $('#launchPhone').val(response[0].phone);
				        $('#launchBusiness').val(response[0].business);
				        $('#launchPostID').val(response[0].postid);
						$('.intro').fadeOut(800, function() {
							$('.user_details').fadeIn(800);
						});
				    } else {
				    	$('#launchError').text('Sorry, that code could not be recognised. Please enter a valid code or continue as a guest');
				    	$('#launchError').fadeIn(800);
				    }

				},  
			    error: function(MLHttpRequest, response, errorThrown){  
			        console.log('Error');
			        console.log(errorThrown);
			    }  
			});
		} else {
			$('#launchError').text('Please enter your unique code, or continue as a guest.');
			$('#launchError').fadeIn(800);
		}
	})

	$('#launchNextGuest').on('click', function() {
		$('#newUser').toggle();
		$('#launchConfirmNew').css('display', 'flex');
		$('.intro').fadeOut(800, function() {
			$('.user_details').fadeIn(800);
		});
	});

	$('#launchConfirmExisting').on('click', function() {
		if(isValid()) { 
			$.ajax({  
				type: 'GET',  
				url: ajaxStuff.ajax_url, 
				data: {  
				    action: 'get_launchUpdateExistingDetails',
				    email: $('#launchEmail').val(),
				    name: $('#launchName').val(),
				    phone: $('#launchPhone').val(),
				    business: $('#launchBusiness').val(),
				    post_id: $('#launchPostID').val(),
				}, 
				success: function(response){ 
				   console.log('Success');
				   $('.user_details, #launchOutput').toggle();
				   $('#launchOutput').text('Thanks! Your attendence has now been registered and an email will follow shortly with confirmation.');
				},  
				error: function(MLHttpRequest, response, errorThrown){  
				    console.log('Error');
				    console.log(errorThrown);
				    $('#launchOutput').text('Sorry, but your details cannot be updated at this time');
				}
			});
		} 
	})

	$('#launchConfirmNew').on('click', function() {
		if(isValid()) {
			$.ajax({  
				type: 'GET',  
				url: ajaxStuff.ajax_url, 
				data: {  
				    action: 'get_launchAddNewUser',
				    email: $('#launchEmail').val(),
				    name: $('#launchName').val(),
				    phone: $('#launchPhone').val(),
				    business: $('#launchBusiness').val(),
				}, 
				success: function(response){ 
					if (response != "0") {
					    console.log('Success');
					    $('.user_details, #launchOutput').toggle();
						$('#launchOutput').text('Thanks! Your attendence has now been registered and an email will follow shortly with confirmation.');
					} else {
						$('#userDetailsError').text('That email address already exists. If you own a member code please go back and enter it into the box displayed, otherwise a unique email address is required.');
					}
				},  
				error: function(MLHttpRequest, response, errorThrown){  
				    console.log('Error');
				    console.log(errorThrown);
				    $('#launchOutput').text('Sorry, but your details cannot be updated at this time');
				}
			});
		}
	})

	function isValid() {
		if (!validateEmail($('#launchEmail').val())) {
			$('#userDetailsError').text('Please enter a valid email address');
			return false;
		}
		if ($('#launchName').val() == "") {
			$('#userDetailsError').text('Please enter your full name');
			return false;
		}
		if ($('#launchPhone').val() != "") {
			if (!validatePhone($('#launchPhone').val())) {
				$('#userDetailsError').text('That is not a valid phone number');
				return false;
			}
		}
		return true;
	}

	function validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	function validatePhone(phone) {
		var re = /^\d+$/;
		return re.test(String(phone).toLowerCase());
	}

	$('.know-more__submit').on('click', function(){
		if(isValidKnowMore()) {
			$.ajax({  
				type: 'GET',  
				url: ajaxStuff.ajax_url, 
				data: {  
				    action: 'sendKnowMoreEmail',
				    email: $('#know-more-email').val(),
				    name: $('#know-more-name').val(),
				    phone: $('#know-more-phone').val(),
				}, 
				success: function(response){ 
					$('#know-more-form').css('display', 'none');
					$('.know-more__thanks').css('display', 'block');
				},  
				error: function(MLHttpRequest, response, errorThrown){  
				    console.log('Error');
				    console.log(errorThrown);
				    $('#userDetailsError').text('Sorry, but your details cannot be updated at this time');
				}
			});
		}
	})

	function isValidKnowMore() {
		if ($('#know-more-name').val() == "") {
			$('#userDetailsError').text('Please enter your full name');
			return false;
		}
		if (!validateEmail($('#know-more-email').val())) {
			$('#userDetailsError').text('Please enter a valid email address');
			return false;
		}
		if ($('#know-more-phone').val() == "") {
			$('#userDetailsError').text('Please enter your phone number');
			return false;
		} else if ($('#know-more-phone').val() != "") {
			if (!validatePhone($('#know-more-phone').val())) {
				$('#userDetailsError').text('That is not a valid phone number');
				return false;
			}
		}
		return true;
	}


    // if ($('.flatpickr-date').length > 0) {
	//     $('.flatpickr-date').flatpickr({
	//     	dateFormat: 'j F Y'
	//     });
	// }

    $('#book-meeting').on('click', function(){
        $('.meeting__response').empty();
        var date = $('#date').val();
        if(date) {
            var name = $('#name').val();
            var email = $('#email').val();
            $.ajax({  
				type: 'POST',  
				url: ajaxStuff.ajax_url, 
				data: {  
				    action: 'confirm_meeting',
				    name: name,
                    email: email,
				    date: date
				}, 
                beforeSend :function() {
                    $('.meeting__form').toggle();
                    $('.meeting__loader').css('display', 'block');
                },
				success: function(){ 
                    $('.meeting__loader').toggle();
					$('.meeting__response').text('Thanks. We will be in touch soon to confirm your booking.');
				},  
				error: function(MLHttpRequest, errorThrown){  
                    $('.meeting__loader').toggle();
				    $('.meeting__response').text('Sorry, but we encountered an error at this time. Please try again later.');
				}
			});
        } else {
            $('.meeting__response').text('Please select your date.');
        }
    })

});